/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */

import { inject } from '@angular/core';
import { MapInteractionsService } from '../../services/mapInteractions.service';
import { DeselectCommand } from './deselect.command';
import { QueryService } from '../../services/query.service';

export function deselectFactory() {
    const dependencies = {
        'interactions': inject(MapInteractionsService),
        'queryService': inject(QueryService)
    };
    const command = new DeselectCommand();
    command.setDependencies(dependencies);
    return command;
}
